import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../components/shared/confirmation-dialog/confirmation-dialog.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(private dialog: MatDialog) { }

  /**
   * Opens a confirmation dialog with the specified title and message
   * @param title The dialog title
   * @param message The dialog message
   * @param confirmText Optional custom text for the confirm button (default: 'Yes')
   * @param cancelText Optional custom text for the cancel button (default: 'No')
   * @returns Observable<boolean> - true if confirmed, false if cancelled
   */
  openConfirmationDialog(
    title: string,
    message: string,
    confirmText: string = 'Yes',
    cancelText: string = 'No',
    confirmIcon: string = 'check',
    cancelIcon: string = 'clear'
  ): Observable<boolean> {
    const dialogRef: MatDialogRef<ConfirmationDialogComponent> = this.dialog.open(
      ConfirmationDialogComponent,
      {
        width: '400px',
        disableClose: false,
        data: {
          title,
          message,
          confirmText,
          cancelText,
          confirmIcon,
          cancelIcon
        }
      }
    );

    return dialogRef.afterClosed();
  }

  openDeleteConfirmationDialog(itemName: string, message?: string): Observable<boolean> {
    return this.openConfirmationDialog(
      'Confirm Delete',
      message || `Are you sure you want to delete "${itemName}"? This action cannot be undone.`,
      'Delete',
      'Cancel',
      'delete',
      'clear'
    );
  }

  openSaveConfirmationDialog(message?: string): Observable<boolean> {
    return this.openConfirmationDialog(
      'Confirm Save',
      message || 'Are you sure you want to save these changes?',
      'Save',
      'Cancel',
      'save',
      'clear'
    );
  }

  openUpdateConfirmationDialog(message?: string): Observable<boolean> {
    return this.openConfirmationDialog(
      'Confirm Update',
      message || 'Are you sure you want to update these changes?',
      'Update',
      'Cancel',
      'save',
      'clear'
    );
  }

  openCreateConfirmationDialog(message?: string): Observable<boolean> {
    return this.openConfirmationDialog(
      'Confirm Create',
      message || 'Are you sure you want to create this item?',
      'Create',
      'Cancel',
      'add',
      'clear'
    );
  }

  openLogoutConfirmationDialog(): Observable<boolean> {
    return this.openConfirmationDialog(
      'Confirm Logout',
      'Are you sure you want to logout?',
      'Logout',
      'Cancel',
      'logout',
      'clear'
    );
  }
}
